

<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Rate Confirmation</title>
  </head>
  <body
    style="
      padding: 5em 5em;
      background: rgb(240, 240, 240);
    ">
    <table cellSpacing="0" cellpadding="0"
      style="background: white; padding: 2em; border-radius: 10px; width: 100%">
      <tr>
        <td>Dear Team,</td>
      </tr>
      <tr>
        <td>
          <p>We are pleased to confirm that the load has been successfully
            picked
            up. For your reference, we have attached the Bill of Lading (BOL)
            along with photographs documenting the load, reefer condition, and
            seal placement.</p>
        </td>
      </tr>
      <tr>
        <td>
          <p>Please inform us immediately if any adjustments to the reefer
            temperature are required. We are currently on standby and ready to
            proceed with delivery.</p>
        </td>
      </tr>
      <tr>
        <td>
          <table cellSpacing="0" cellpadding="0"
            style="border: 1px solid #dfdfdf; border-radius: 0.5em; overflow: hidden;">
            <thead>
              <tr style="background: rgb(245, 245, 245);">
                <th style="padding: 0.5em; border: 1px solid #dfdfdf;">PO</th>
                <th style="padding: 0.5em; border: 1px solid #dfdfdf;">PU</th>
                <th
                  style="padding: 0.5em; border: 1px solid #dfdfdf;">Cases/Pallets</th>
                <th
                  style="padding: 0.5em; border: 1px solid #dfdfdf;">Temp.</th>
                <th style="padding: 0.5em; border: 1px solid #dfdfdf;">Seal</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  style="padding: 0.5em 1em; border: 1px solid #dfdfdf;">0592166</td>
                <td
                  style="padding: 0.5em 1em; border: 1px solid #dfdfdf;">25006939
                  / 416331</td>
                <td style="padding: 0.5em 1em; border: 1px solid #dfdfdf;">6329
                  Cases</td>
                <td style="padding: 0.5em 1em; border: 1px solid #dfdfdf;">-20
                  Cont.</td>
                <td
                  style="padding: 0.5em 1em;border: 1px solid #dfdfdf;">1742583</td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
      <tr>
        <td>
          <p>For timely updates on this shipment, please include <a
              href="mailto:tracking@manntransinc.com"
              class="tracking-link">{{'tracking@manntransinc.com'}}</a> in all
            correspondence.</p>
        </td>
      </tr>
      <tr>
        <td>
          <p>Important Notice</p>
        </td>
      </tr>
      <tr>
        <td>
          <p>If the load value exceeds $100,000, please provide written
            notification immediately. Please note that claims above this value
            cannot be processed without prior written authorization.</p>
        </td>
      </tr>
      <tr>
        <td>
          <p>As a matter of company policy, Mann Trans Inc. does not request
            advance payments under any circumstances.</p>
        </td>
      </tr>
      <tr>
        <td>
          <p>Should your logistics protocol require our drivers to utilize
            MacroPoint or other tracking applications, please advise us
            accordingly and we will ensure compliance.</p>
        </td>
      </tr>
      <tr>
        <td>
          <p>Thank you, <br>Ashish </p>
        </td>
      </tr>
      <tr>
        <td>
          <p><strong>MC:</strong> 073132</p>
          <p><strong>Phone:</strong> 561-494-5275</p>
          <p><strong>Dispatch:</strong> <a
              href="mailto:loads@manntransinc.com">{{"loads@manntransinc.com"}}</a></p>
          <p><strong>Tracking:</strong> <a
              href="mailto:tracking@manntransinc.com">{{'tracking@manntransinc.com'}}</a></p>
          <p><strong>Billing:</strong> <a
              href="mailto:accounting@manntransinc.com">{{'accounting@manntransinc.com'}}</a></p>
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRFWI_kFkUnIXANntquTGV60C_S7g883BgPaw&s"
            alt="Mann Trans Logo" />
        </td>
      </tr>
      <tr>
        <td>
          <p>Thank you for your business. We value your partnership and look
            forward
            to serving you.</p>
          <p>&copy; 2025 Mann Loads. All rights reserved.</p>
        </td>
      </tr>
    </table>
  </body>
</html>
